import { takeEvery, fork, put, all, call, select } from "redux-saga/effects";
import {
    getTransactionsSuccessful,
    getTransactionsError,
    getFilteredTransactionsSuccessful,
    getFilteredTransactionsError,
    createInvoiceError,
    createInvoiceSuccess,
    getInvoicesError,
    getInvoicesSuccessful,
    setProfPayQuery
} from "./actions";
import ProfPaymentsService from "./service";
import { PaymentsActionTypes } from "./actionTypes";

// Selector to get the profPayments query state from the Redux store.
export const getProfPayQuery = state => state.ProfPayments.query;

function* getAllTransactions({payload}) {
    try {
        // Get the current query from the Redux store.
        const storedQuery = yield select(getProfPayQuery);
        // The payload from the action can override the stored query for this specific call.
        const finalPayload = { ...storedQuery, ...payload };
        const response = yield call(ProfPaymentsService.getTransactions, finalPayload);
        yield put(getTransactionsSuccessful(response));
        yield put(setProfPayQuery(finalPayload));
    } catch (error) {
        yield put(getTransactionsError(error));
    }
}

function* getAllInvoices({payload}) {
    try {
        // Get the current query from the Redux store.
        const storedQuery = yield select(getProfPayQuery);
        // The payload from the action can override the stored query for this specific call.
        const finalPayload = { ...storedQuery, ...payload };
        const response = yield call(ProfPaymentsService.getInvoices, finalPayload);
        yield put(getInvoicesSuccessful(response));
        yield put(setProfPayQuery(finalPayload));
    } catch (error) {
        yield put(getInvoicesError(error));
    }
}

export function* watchGetInvoicing() {
    yield takeEvery(PaymentsActionTypes.PROFPAY_LIST_GET, getAllTransactions);
}


export function* watchGetProfPayments() {
    yield takeEvery(PaymentsActionTypes.PROF_LIST_GET, getAllInvoices);
}


function* getFiltered({payload}) {
    try {
        const response = yield call(ProfPaymentsService.getFilteredTransactions, { professionalID: payload });
        const rsp = getFilteredTransactionsSuccessful(response);
        yield put(rsp);
    } catch (error) {
        yield put(getFilteredTransactionsError(error));
    }
}
export function* watchFilterInvoicing() {
    yield takeEvery(PaymentsActionTypes.PROFPAY_GET_FILTERED, getFiltered);
}


function* createInvoiceSaga({payload}) {
    try {
        const response = yield call(ProfPaymentsService.createInvoice, { transactions: payload });
        const rsp = createInvoiceSuccess(response);
        yield put(rsp);
    } catch (error) {
        yield put(createInvoiceError(error));
    }
}
export function* watchCreateInvoice() {
    yield takeEvery(PaymentsActionTypes.PROFPAY_CREATE, createInvoiceSaga);
}



function* profPaymentsSaga() {
    yield all([
        fork(watchGetInvoicing),
        fork(watchFilterInvoicing),
        fork(watchCreateInvoice),
        fork(watchGetProfPayments),
    ]);
}



export default profPaymentsSaga;
